<template>
  <div>
    <v-widget
      :title="$t('Tax rates')"
    >
      <div
        slot="widget-header-action"
        class="my-3"
      />
      <div slot="widget-content">
        <template
          v-if="newTaxRates && newTaxRates.length"
        >
          <v-layout
            v-for="tax in newTaxRates"
            :key="tax.uuid"
            class="d-flex"
          >
            <v-flex
              :class="newTaxRates.length > 1 ? 'xs10' : 'xs12'"
            >
              <SettingsTaxRateForm
                :tax-rate="tax"
              />
            </v-flex>
            <v-flex xs2>
              <v-icon
                v-if="newTaxRates.length > 1"
                class="ml-2 mt-2"
                large
                @click="$emit('removeNewTaxRate', tax.uuid)"
              >close</v-icon>
            </v-flex>
          </v-layout>
          <v-btn
            @click="$emit('addNewTaxRate', false)"
          >
            {{ $t('Add more tax rates') }}
          </v-btn>
        </template>
        <SettingsTaxRateForm
          v-if="selectedTax && selectedTax.id"
          :tax-rate="selectedTax"
        />
      </div>
    </v-widget>
  </div>
</template>

<script>
import SettingsTaxRateForm from './SettingsTaxRateForm'

export default {
  name: 'SettingsTaxRateWidget',

  components: {
    SettingsTaxRateForm
  },

  props: {
    selectedTax: {
      type: Object,
      default: () => {}
    },
    newTaxRates: {
      type: Array,
      default: () => []
    }
  }
}
</script>
